var map = {
	"./bicycles_featured.jpg": 761,
	"./coffee_featured.jpg": 762,
	"./flowers_featured.jpg": 763,
	"./handbags_featured.jpg": 764,
	"./paper_featured.jpg": 765,
	"./spice_featured.jpg": 766
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 760;